import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-lopd',
  templateUrl: './lopd.component.html',
  styleUrls: ['./lopd.component.scss'],
})
export class LopdComponent implements OnInit {
  language: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.language = params['language'];
    });
  }
}
